<template>
  <div>
    <!-- 新增按钮 -->

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
    <Modal v-model="modal1" title="连续登录" width="300">
      <!-- <div>{{ lianxu }}</div> -->
      <div v-html="lianxu"></div>

      <div slot="footer">
        <Button @click="cancelFenghao">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getCensusData } from "../../api/user";

export default {
  components: {},
  data() {
    return {
      selUser: {},
      modal1: false,

      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,

      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      lianxu: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "日期",
          key: "createtime",
        },
        {
          title: "新用户数量",
          key: "newUserCount",
        },
        {
          title: "新用户游戏数",
          key: "activeUserGameCount",
        },
        {
          title: "总人数",
          key: "totalPlayerCount",
        },

        {
          title: "日活",
          key: "activeUserCount",
        },
        {
          title: "游戏时长",
          key: "gameDuration",
        },
        {
          title: "平均玩家游戏周期",
          key: "averageGameCycle",
        },
        {
          title: "七日流失率",
          key: "churnRate",
        },
        {
          title: "七日连续日活数据",
          key: "dailyActiveUsers",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.lianxu = "";
                      var dailyActiveUsers = JSON.parse(
                        params.row.dailyActiveUsers
                      );
                      for (var i = 0; i < dailyActiveUsers.length; i++) {
                        var item = dailyActiveUsers[i];
                        this.lianxu += `<p>第${item.day}天, 连续日活${item.activeUsers}人;</p>`;
                      }
                      //     this.lianxu =
                      //       this.lianxu +
                      //       "第" +
                      //       item.day +
                      //       "天,连续日活" +
                      //       item.activeUsers +
                      //       "人;\n\r";
                      //   }
                      this.modal1 = true;
                    },
                  },
                },
                "详情"
              ),
            ]);
          },
        },
      ],

      current: 1,
      total: 0,
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    close() {
      this.visible = false;
    },
    // disabledDate(date) {
    //   // 禁止选择今天及以后的日期

    // },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      getCensusData(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.totalPages; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
    cancelFenghao() {
      this.modal1 = false;
    },
  },
};
</script>
